import React, { useEffect } from 'react'
import { ICreateExpenseData, ItemInput } from '../../../../@types';
import { INVOICE_TABLE_HEADER } from '../../../../constants';
import useLineItems from '../../../../modules/lineItem';
import { formatMoney } from '../../../../utils';
import { clearFieldError } from '../../../../utils/handleErrors';
import { LineItemTable, TableColumn } from '../../../common/LineItemTable';


interface ExpenseDetailTwoProps {
  formData:  ICreateExpenseData;
  updatedNewItem?: ItemInput;
expense: ICreateExpenseData;
setFormData:React.Dispatch<React.SetStateAction<ICreateExpenseData>>;
validateCurrentStep: () => boolean;
validationResults: ICreateExpenseData;
setValidationResults: React.Dispatch<React.SetStateAction<ICreateExpenseData>>;
}

const ExpenseDetailTwo: React.FC<ExpenseDetailTwoProps> = ({
  formData, 
expense,
setFormData,
validateCurrentStep,
validationResults,
setValidationResults,
}) => {

   const columns: TableColumn[] = INVOICE_TABLE_HEADER;
  
   const { items, addItem, setItems, removeItem, updateCell, updateRow } = useLineItems([expense?.lineItems.length ? expense?.lineItems : { id: '', name: '', rate: 0, quantity: 0 }]);
 
  const [total, setTotal] = React.useState<number>(0);

  const handleInputChange = (event: { target: { name: any; value: any } }): void => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  const updatedItems = items.map((item) => {
    if (item.id === name) {
      return { ...item, quantity: value };
    }
    return item;
  });
  // @ts-ignore
  setItems(updatedItems);
  setFormData((prevState: ICreateExpenseData) => ({
    ...prevState,
    lineItems: updatedItems,
  }));
  const _total = updatedItems.reduce((total, exp) => total + exp.rate || 0 || 0, 0);
  setTotal(_total);
   clearFieldError(name, validationResults, setValidationResults);
};
  React.useEffect(() => {
    clearFieldError('lineItems', validationResults, setValidationResults);
    setFormData((prevState: ICreateExpenseData) => ({
      ...prevState,
      lineItems: items.map(item => {
        return {
          ...item,
          amount: item.rate * item.quantity 
        }
        
      }),
    }));

    const total = items.reduce((total, exp) => total + exp.rate * exp.quantity || 0 || 0, 0);
    setTotal(total);
    
   
  }, [items]);

  

  useEffect(() => {
    if (expense) {
      console.log('Fetched expense:', expense);
      setFormData((prevState) => ({
        ...prevState,
        notes: expense.notes,
        customerId: expense.customerId,
        customerName: expense.customerName,
        vendorName: expense.vendorName,
        amount: expense.amount,
        description: expense.description,
        paymentMethod: expense.paymentMethod,
        lineItems: expense.lineItems,
        currency: expense.currency,
        category: expense.category,
        isBillable:expense.isBillable
      }));
  
      const newItems = expense.lineItems.map((lineItem: any) => ({
        id: lineItem.id,
        name: lineItem.name,
        quantity: lineItem.quantity,
        rate: parseFloat(lineItem.rate)
      }));
      
      setItems(newItems);
  
     
    }
  }, [expense]);
  
 
  return (
    <div>
    <h2 className="xl:text-[24px] text-center mt-[1em]">Fill in Details About the Items</h2>
    <div className="flex justify-center">
      <div className="mt-[2em]">
        <LineItemTable
          columns={columns}
          items={items}
          isSearchInput={false}
          addItem={addItem}
          removeItem={removeItem}
          updateCell={updateCell}
          updateRow={updateRow}
          isImportedToInvoice={true}
        />
        {validationResults.lineItems && (
          <span className="text-red-500" style={{ whiteSpace: 'nowrap' }}>
            {validationResults.lineItems}
          </span>
        )}
      </div>
    </div>
    <div className="flex flex-col justify-end items-end mt-[3em] ">
        <label htmlFor="total" className="block text-[14px] " style={{ whiteSpace: 'nowrap' }}>
          Total Amount:
        </label>
        <span
          className="text-red-500 text-lg font-bold"
          id="totalAmount"
          style={{ paddingLeft: '5px' }}
        >
          {`₦${total.toFixed(2)}`}                                                
       
        </span>
      </div>
  </div>
  
  )
}

export default ExpenseDetailTwo